import { render, staticRenderFns } from "./tipModal.vue?vue&type=template&id=014c1326&scoped=true"
import script from "./tipModal.vue?vue&type=script&lang=js"
export * from "./tipModal.vue?vue&type=script&lang=js"
import style0 from "./tipModal.vue?vue&type=style&index=0&id=014c1326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014c1326",
  null
  
)

export default component.exports